import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getPartsActions, setPartsSearchAction } from '../../redux/actions/partsActions';
import CreatePartModal from './modals/CreatePartModal';

const PartsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.parts?.search);
  const [showCreatePartModal, setShowCreatePartModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setPartsSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handlePartModalSubmit = async () => {
    setShowCreatePartModal(false);
    setLoading(true);
    await dispatch(getPartsActions(search));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreatePartModal && (
        <CreatePartModal
          onModalSubmit={() => handlePartModalSubmit()}
          onModalClose={() => setShowCreatePartModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreatePartModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default PartsHeader;
